import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { appInjector } from '../../app-injector';
import { AuthenticationService } from '../../core-services';
import { ConfigurationService } from '../../system-configuration/Configuration.service';
import { ApiService } from '../../system-services/Api.service';
@Injectable({
    providedIn: 'root'
})
export class LogEntryApi {
    static readonly endpoint: string = '/api/v3/logentrys/';

    constructor(
        private api: ApiService,
        private config: ConfigurationService
    ) {}

    createLogEntry(data: any): Promise<string> {
        return this.api
            .post<any, string>(LogEntryApi.endpoint, data, undefined, () => {
                // An empty function is passed in to swallow any errors!
            })
            .then(([responseData]) => responseData);
    }

    // Cannot use API here because we need the keepalive behavior for this logger
    // The AuthInterceptor adds a bearer token via middleware, but a fetch bypasses all middleware
    // We cannot resolve an AuthService in the constructor due to a circular dependency issue.
    createLogEntryWithoutReturn(data: any) {
        const authService = this.resolveAuthService();

        firstValueFrom(authService.getToken())
            .then((token: string) => {
                this.createPromiseLogEntryWithNoReturn(data, token);
            })
            .catch((error) => console.log(error));
    }

    private resolveAuthService(): AuthenticationService {
        return appInjector().get(AuthenticationService);
    }

    private createPromiseLogEntryWithNoReturn(data: any, token: string) {
        fetch(this.config.getUrlWithHost(LogEntryApi.endpoint), {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            keepalive: true
        }).catch((error) => console.log(error));
    }
}
